// src/supabaseClient.js
import { createClient } from '@supabase/supabase-js';

// 1. Läs in uppgifter från miljövariabler med dina nuvarande nycklar som säker fallback
const supabaseUrl = 
  process.env.REACT_APP_SUPABASE_URL || 'https://jdcsceygyfnhkitqwqga.supabase.co';

const supabaseKey = 
  process.env.REACT_APP_SUPABASE_ANON_KEY || 'sb_publishable_Bt2_YglxGEE8LLV9r08_4Q_ptgRx1Hs';

// 2. Varna under lokal utveckling om miljövariablerna saknas i .env
if (!process.env.REACT_APP_SUPABASE_URL || !process.env.REACT_APP_SUPABASE_ANON_KEY) {
  console.warn(
    '⚠️ Supabase: REACT_APP_SUPABASE_URL eller REACT_APP_SUPABASE_ANON_KEY saknas i miljövariablerna. Använder fallback-konfiguration.'
  );
}

// 3. Exportera den gemensamma klienten för hela applikationen
export const supabase = createClient(supabaseUrl, supabaseKey);